/**
 * Canonical route identities for manual market-price management.
 * Kept beside the route registry so generic resource descriptors can expose
 * the already-authorized MARKET_DATA_CREATE / MARKET_DATA_UPDATE operations
 * without inventing browser-local destinations.
 */
export const MARKET_PRICE_ROUTE_IDS = Object.freeze({
    CREATE: 'data-market-price-create',
    EDIT: 'data-market-price-edit',
});
